/**
 * @description 입력받은 element에서 filter에 부합하는 부모 element 들을 반환
 * @function getParents
 * @param {HTMLElement} element
 * @param {String} filter
 * @returns {Array} filter 조건에 부합하는 부모 element들을 배열에 넣어 반환. 없다면 빈 배열 반환
 */
function getParents(element: HTMLElement, filter: any /* optional */) {
  // If no parentSelector defined will bubble up all the way to *document*
  if (filter === undefined) {
    filter = document;
  }

  var parents = [];
  var p = element.parentNode;

  while (p !== undefined) {
    var o: any = p;

    if (o.classList === undefined) {
      break;
    }

    if (o.classList.contains(filter)) {
      parents.push(o);
    }
    if (o.parentNode === undefined) {
      break;
    }

    p = o.parentNode;
  }

  return parents;
}

export default getParents;
